import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import {  BrowserRouter as Router,  Routes,  Route, BrowserRouter} from "react-router-dom";
import './index.scss';
import 'macro-css'
import App from './App';
import store from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
    <BrowserRouter>
    <Provider store={store}>
      <App/>
    </Provider>
    </BrowserRouter>
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

